import { render, staticRenderFns } from "./PriorityRule.vue?vue&type=template&id=dfed5fe6&"
import script from "./PriorityRule.vue?vue&type=script&lang=ts&"
export * from "./PriorityRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports